import {capitalize} from "@material-ui/core";


export const measurementLabel = measure => capitalize(measure.replaceAll("_", " "));

export const productMatchCondition = measure => capitalize(measure.replaceAll("_", " "));
